import { render } from "./ImageModal.vue?vue&type=template&id=0b30652a&scoped=true"
import script from "./ImageModal.vue?vue&type=script&lang=js"
export * from "./ImageModal.vue?vue&type=script&lang=js"

import "./ImageModal.vue?vue&type=style&index=0&id=0b30652a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b30652a"]])

export default __exports__